import { Injectable } from '@angular/core';
import { Order } from '@app/entities/orders/interfaces/order';
import { OrdersService } from '@app/entities/orders/services/orders.service';
import { PaginatedResults } from '@app/interfaces/paginated-results';
import { ImmutableContext } from '@ngxs-labs/immer-adapter';
import { Action, State, StateContext } from '@ngxs/store';
import { tap } from 'rxjs/operators';
import { DownloadsStateModel } from './downloads-state.model';
import { LoadDownloads } from './downloads.actions';

@State<DownloadsStateModel>({
  name: 'downloads',
})
@Injectable()
export class DownloadsState {
  constructor(private ordersService: OrdersService) {}

  @Action(LoadDownloads, { cancelUncompleted: true })
  @ImmutableContext()
  loadDownloads(
    { getState, setState }: StateContext<DownloadsStateModel>,
    { preserveResults }: LoadDownloads,
  ) {
    const nextPage = preserveResults ? getState().page + 1 : 1;

    return this.ordersService.getDownloads(nextPage).pipe(
      tap((paginatedResults: PaginatedResults<Order>) => {
        return setState((state: DownloadsStateModel) => {
          state.page = nextPage;
          state.orders = preserveResults
            ? [...(state.orders || []), ...paginatedResults.results]
            : paginatedResults.results;
          state.totalCount = paginatedResults.count;

          return state;
        });
      }),
    );
  }
}
